import { Box, InputLabel } from '@mui/material';

import FHSelect from '../../base/FHSelect';
import BaseFieldContainer from '../common/baseFieldContainer';
import { buildDateTimePickerInputLabelSx } from '../fDateTimePicker/utils';
import { SELECT_PLACEHOLDER_SX } from './styles';

import type { FSelectProps } from './types';

export default function FSelect({
  id,
  label,
  required,
  showRequiredIndicator,
  disabled,
  helperText,
  fullWidth,
  inputHeight = 40,
  sx,
  placeholder,
  displayEmpty,
  renderValue,
  ...props
}: FSelectProps) {
  const shouldRenderDefaultPlaceholder = placeholder != null && renderValue == null;
  let selectRenderValue: FSelectProps['renderValue'] = renderValue;
  if (shouldRenderDefaultPlaceholder) {
    selectRenderValue = (value) => {
      if (value) {
        return props.options.find((option) => option.value === value)?.label ?? String(value);
      }
      return (
        <Box component="span" sx={SELECT_PLACEHOLDER_SX}>
          {placeholder}
        </Box>
      );
    };
  }

  return (
    <BaseFieldContainer
      required={required}
      showRequiredIndicator={showRequiredIndicator}
      disabled={disabled}
      helperText={helperText}
      error={props.error ?? false}
      fullWidth={fullWidth}
      alwaysRenderContainer
    >
      {label != null ? (
        <InputLabel
          disabled={disabled}
          error={props.error ?? false}
          required={required && !disabled ? false : required}
          shrink
          htmlFor={id}
          sx={buildDateTimePickerInputLabelSx(undefined, false)}
        >
          {label}
        </InputLabel>
      ) : null}
      <FHSelect
        {...props}
        id={id}
        disabled={disabled}
        fullWidth={fullWidth}
        inputHeight={inputHeight}
        sx={sx}
        displayEmpty={shouldRenderDefaultPlaceholder || displayEmpty}
        renderValue={selectRenderValue}
      />
    </BaseFieldContainer>
  );
}
